import * as Icons from "lucide-react";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Reveal } from "@/components/Reveal";
import { SectionHeading } from "@/components/SectionHeading";
import { SERVICES } from "@/data/services";

const scrollTo = (id) => (e) => {
  e.preventDefault();
  document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });
};

export const Services = () => {
  return (
    <section
      id="servicos"
      data-testid="services-section"
      className="section-padding relative scroll-mt-24 bg-[hsl(var(--brand-off-white))]"
    >
      <div className="noise-overlay" aria-hidden="true" />
      <div className="container-site relative flex flex-col gap-14">
        <Reveal className="flex flex-col gap-8 lg:flex-row lg:items-end lg:justify-between">
          <SectionHeading
            id="services"
            eyebrow="Serviços"
            title="Cuidado completo para cada fase do seu sorriso."
            description="Da prevenção à estética, cada tratamento é planejado com atenção aos detalhes e ao seu conforto."
          />
          <Button
            asChild
            variant="secondary"
            className="h-12 w-fit rounded-xl border border-border px-6 active:scale-[0.98] transition-[background-color,transform] duration-200"
          >
            <a href="#agendamento" onClick={scrollTo("agendamento")} data-testid="services-cta-button">
              Solicitar agendamento
              <ArrowRight className="h-4 w-4" />
            </a>
          </Button>
        </Reveal>

        <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-testid="services-grid">
          {SERVICES.map((service, i) => {
            const Icon = Icons[service.icon] || Icons.Circle;
            return (
              <Reveal key={service.id} delay={0.06 * i}>
                <article
                  data-testid={`service-card-${service.id}`}
                  className="card-premium group flex h-full flex-col gap-5 p-6 transition-[transform,box-shadow] duration-200 hover:-translate-y-0.5 hover:shadow-[0_14px_40px_rgba(20,16,12,0.10)]"
                >
                  <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-[hsl(var(--brand-beige))] text-[hsl(var(--brand-soft-brown))] transition-colors duration-200 group-hover:bg-[hsl(var(--brand-champagne-gold))]/25">
                    <Icon className="h-5 w-5" />
                  </div>
                  <div className="flex flex-1 flex-col gap-2">
                    <h3 className="font-heading text-xl font-semibold text-foreground">{service.title}</h3>
                    <p className="text-sm leading-relaxed text-muted-foreground sm:text-base">{service.description}</p>
                  </div>
                  <a
                    href="#agendamento"
                    onClick={scrollTo("agendamento")}
                    data-testid={`service-card-${service.id}-link`}
                    className="inline-flex w-fit items-center gap-1.5 rounded-md text-sm font-semibold text-[hsl(var(--brand-soft-brown))] transition-colors duration-200 hover:text-[hsl(var(--brand-champagne-gold))] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
                  >
                    Solicitar avaliação
                    <ArrowRight className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-0.5" />
                  </a>
                </article>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
